module.exports = __webpack_public_path__ + "static/media/redigera_text.1ce463b4.png";